import { AppState } from "./model";
import { ohCaseSelector } from "./selectors";
import { detailRoutes } from "./detailRoutes";
import { referAgainRoutes } from "./components/referAgain/referAgainRoutes";
import { manageAssignedUsersRoutes } from "./components/manageAssignedUsers/manageAssignedUsersRoutes";

const detailRoute = () => ({
    "/:ohCaseId": {
        title: (state: AppState) => ohCaseSelector(state)
            ? `${ohCaseSelector(state).employeeFirstName} ${ohCaseSelector(state).employeeLastName}`
            : "Case",
        "/edit": {
            title: "Edit",
        },
        "/manageAssignedUsers": {
            title: "Manage Assigned Users",
        },
        ...detailRoutes,
        ...referAgainRoutes,
        ...manageAssignedUsersRoutes
    }
});

export const routes = {
    "/ohCases": {
        title: "Cases",
        ...detailRoute(),
        "/create": {
            title: "Create Case"
        }
    },
    "/workadjustments": {
        title: "Work adjustments",
        ...detailRoute(),
        "/create": {
            title: "Create Case"
        }
    }
};
